import { create } from 'zustand'
import type { GetAnswersFilter } from '../types/assessment.types'

interface AnswersFilterState {
  filters: GetAnswersFilter
  setFilters: (filters: Partial<GetAnswersFilter>) => void
  resetFilters: () => void
  setPeriodId: (periodId: string | undefined) => void
  setRole: (role: string | undefined) => void
  setLevel: (level: string | undefined) => void
  setName: (name: string | undefined) => void
  setSubName: (subName: string | undefined) => void
  setResponseType: (responseType: string | undefined) => void
  setAssessmentTypeId: (assessmentTypeId: string | undefined) => void
}

const initialFilters: GetAnswersFilter = {
  periodId: undefined,
  role: undefined,
  level: undefined,
  name: undefined,
  subName: undefined,
  responseType: undefined,
  assessmentTypeId: undefined,
}

export const useAnswersFilterStore = create<AnswersFilterState>((set) => ({
  filters: initialFilters,

  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),

  resetFilters: () =>
    set({
      filters: initialFilters,
    }),

  setPeriodId: (periodId) =>
    set((state) => ({
      filters: { ...state.filters, periodId },
    })),

  setRole: (role) =>
    set((state) => ({
      filters: { ...state.filters, role },
    })),

  setLevel: (level) =>
    set((state) => ({
      filters: { ...state.filters, level },
    })),

  setName: (name) =>
    set((state) => ({
      filters: { ...state.filters, name },
    })),

  setSubName: (subName) =>
    set((state) => ({
      filters: { ...state.filters, subName },
    })),

  setResponseType: (responseType) =>
    set((state) => ({
      filters: { ...state.filters, responseType },
    })),

  setAssessmentTypeId: (assessmentTypeId) =>
    set((state) => ({
      filters: { ...state.filters, assessmentTypeId },
    })),
}))
